import {StoreType} from '../../../types/sharedTypes';

export const allInboundsSelector = (state: StoreType) => {
  return state.inboundReducer.inboundResult;
}
